import React, {Component} from 'react';

import _ from "lodash";

import DischargeDone from "../Discharge/DischargeDone";
import Accordeon from "../../../../../components/Accordeon/accordeon";
import formatters from "../../../../../utils/formatters";

export default class TripDischarge extends Component {

    componentDidMount(){
        window.initializeCollapsible();
    }

    render() {
        let trip = this.props.trip;
        if(!trip)return <div />;

        let {product} = trip;
        let dischargeLabel = '';
        if(product){
            if(product.terminal_unit_of_measure){
                dischargeLabel = _.capitalize(product.terminal_unit_of_measure);
                if(product.terminal_density){
                    dischargeLabel = `${dischargeLabel} a ${formatters.floatFormat(product.terminal_density)}º`;
                }
            }
        }


        let form = (
            <div>
                {trip.discharge.length > 0 &&
                    <ul className="collapsible no-margin grey-collapsible" data-collapsible="expandable">
                        {trip.discharge.map((discharge, index) => {
                            let {initial_totalizer, final_totalizer} = discharge;
                            let secondary_text = null;
                            if (initial_totalizer >= 0 && final_totalizer >= 0) {
                                secondary_text = `Litros: ${formatters.intFormat(final_totalizer - initial_totalizer)} ${dischargeLabel}`
                            }
                            let active = (this.props.boxed && index === 0);
                            return (
                                <Accordeon active={active}
                                           secondary_text={secondary_text}
                                           name={`Descarga ${index + 1}`} key={`discharge-${index}`}>
                                    <DischargeDone discharge={discharge}/>
                                </Accordeon>
                            );
                        })}
                    </ul>
                }

                {trip.discharge.length === 0 &&
                    <div className={"waiting-continer valign-wrapper w100"}>
                        <p className={"w100 center"}>
                            Este viaje no posee descargas
                        </p>
                    </div>
                }
            </div>
        );

        if(this.props.boxed){
            return (
                <div className={"trip-section"}>
                    <div className={'trip-section-title'}>Descarga</div>
                    {form}
                </div>
            );
        }

        return form;
    }
}


// WEBPACK FOOTER //
// ./src/containers/Dashboard/Trips/Trip/Done/TripDischarge.js